import { BaseClient } from "../../../http/base-client";
import { User } from "@autom8n/users";
import type { OAuthProvider } from "../types/oauth2-provider";
import z from "zod";

export class AuthClient extends BaseClient {
  public async authenticate() {
    return await this.get({
      url: "/api/me",
      responseSchema: User,
    });
  }

  public async deleteAccount() {
    return await this._delete({
      url: "/api/user",
    });
  }

  public async listOauthProviders() {
    return await this.get({
      url: "/api/oauth2/providers",
    });
  }

  public async oauth2Redirect({
    code,
    provider,
  }: {
    code: string;
    provider: Pick<OAuthProvider, "name" | "codeVerifier">;
  }) {
    return await this.post({
      url: "/api/oauth2/redirect",
      body: {
        code,
        provider,
      },
      bodySchema: z.object({
        code: z.string(),
        provider: z.object({
          name: z.string(),
          codeVerifier: z.string(),
        }),
      }),
    });
  }
}
